export const nlCybersecurity = {
  title: "Cybersecurity Adviesdiensten",
  description: "Uitgebreide beveiligingsoplossingen om uw digitale activa te beschermen, naleving te waarborgen en cyberdreigingen te beperken.",
  subtitle: "Cybersecurity Adviesoplossingen",

  servicesTitle: "Onze Cybersecurity Expertise",
  servicesSubtitle: "End-to-end beveiligingsdiensten op maat van uw organisatie",
  services: {
    assessment: {
      title: "Beveiligingsbeoordelingen",
      description: "Identificeer kwetsbaarheden en risico's met uitgebreide beveiligingsevaluaties.",
      technologies: ["Penetratietesten", "Kwetsbaarheidsscans", "Risicoanalyse", "Dreigingsmodellering", "Beveiligingsaudits"]
    },
    compliance: {
      title: "Compliance Advies",
      description: "Bereik en behoud naleving van industriestandaarden.",
      technologies: ["AVG", "HIPAA", "PCI DSS", "ISO 27001", "SOC 2"]
    },
    cloudsec: {
      title: "Cloudbeveiliging",
      description: "Beveilig uw cloudinfrastructuur en applicaties met best practices.",
      technologies: ["AWS Beveiliging", "Azure Beveiliging", "GCP Beveiliging", "Cloudarchitectuur", "CSPM"]
    },
    incident: {
      title: "Incidentrespons",
      description: "Bereid u voor op en reageer effectief op beveiligingsinbreuken.",
      technologies: ["IR Planning", "Forensisch onderzoek", "Threat Hunting", "Beperking van inbreuken", "Herstel"]
    },
    training: {
      title: "Beveiligingstraining",
      description: "Train uw team in cybersecurity best practices en bewustwording.",
      technologies: ["Phishing Simulaties", "Beveiligingsworkshops", "Beleidsontwikkeling", "Tabletop-oefeningen", "Compliance Training"]
    },
    architecture: {
      title: "Beveiligingsarchitectuur",
      description: "Ontwerp en implementeer robuuste beveiligingskaders voor uw systemen.",
      technologies: ["Zero Trust", "Netwerkbeveiliging", "IAM Oplossingen", "Endpointbescherming", "Encryptie"]
    }
  },

  processTitle: "Ons Beveiligingsproces",
  processSteps: [
    {
      title: "Dreigingsbeoordeling",
      description: "Evalueer uw huidige beveiligingspositie en identificeer kwetsbaarheden."
    },
    {
      title: "Strategieontwikkeling",
      description: "Maak een op maat gemaakte beveiligingsroutekaart voor uw organisatie."
    },
    {
      title: "Implementatie",
      description: "Implementeer beveiligingsmaatregelen en controles in uw infrastructuur."
    },
    {
      title: "Testen & Validatie",
      description: "Controleer de effectiviteit van beveiligingsimplementaties."
    },
    {
      title: "Monitoring",
      description: "Monitor systemen continu op potentiële dreigingen."
    },
    {
      title: "Voortdurende Optimalisatie",
      description: "Werk beveiligingsmaatregelen regelmatig bij en verbeter ze."
    }
  ]
};

export const deCybersecurity = {
  title: "Cybersecurity Beratungsdienste",
  description: "Umfassende Sicherheitslösungen zum Schutz Ihrer digitalen Vermögenswerte, zur Einhaltung von Vorschriften und zur Abwehr sich entwickelnder Cyber-Bedrohungen.",
  subtitle: "Cybersecurity Beratungslösungen",

  servicesTitle: "Unsere Cybersecurity Expertise",
  servicesSubtitle: "Umfassende Sicherheitsdienste, maßgeschneidert für Ihr Unternehmen",
  services: {
    assessment: {
      title: "Sicherheitsbewertungen",
      description: "Identifizieren Sie Schwachstellen und Risiken mit umfassenden Sicherheitsbewertungen.",
      technologies: ["Penetrationstests", "Schwachstellen-Scans", "Risikoanalyse", "Bedrohungsmodellierung", "Sicherheitsaudits"]
    },
    compliance: {
      title: "Compliance Beratung",
      description: "Erreichen und erhalten Sie die Einhaltung von Industriestandards.",
      technologies: ["DSGVO", "HIPAA", "PCI DSS", "ISO 27001", "SOC 2"]
    },
    cloudsec: {
      title: "Cloud-Sicherheit",
      description: "Sichern Sie Ihre Cloud-Infrastruktur und Anwendungen mit Best Practices.",
      technologies: ["AWS Sicherheit", "Azure Sicherheit", "GCP Sicherheit", "Cloud-Architektur", "CSPM"]
    },
    incident: {
      title: "Incident Response",
      description: "Bereiten Sie sich auf Sicherheitsverletzungen vor und reagieren Sie effektiv darauf.",
      technologies: ["IR Planung", "Forensik", "Threat Hunting", "Eindämmung von Verstößen", "Wiederherstellung"]
    },
    training: {
      title: "Sicherheitsschulungen",
      description: "Schulen Sie Ihr Team in Cybersecurity Best Practices und Sensibilisierung.",
      technologies: ["Phishing-Simulationen", "Sicherheitsworkshops", "Policy-Entwicklung", "Tabletop-Übungen", "Compliance-Schulungen"]
    },
    architecture: {
      title: "Sicherheitsarchitektur",
      description: "Entwerfen und implementieren Sie robuste Sicherheitsrahmen für Ihre Systeme.",
      technologies: ["Zero Trust", "Netzwerksicherheit", "IAM-Lösungen", "Endpunktschutz", "Verschlüsselung"]
    }
  },

  processTitle: "Unser Sicherheitsprozess",
  processSteps: [
    {
      title: "Bedrohungsbewertung",
      description: "Bewerten Sie Ihre aktuelle Sicherheitslage und identifizieren Sie Schwachstellen."
    },
    {
      title: "Strategieentwicklung",
      description: "Erstellen Sie eine maßgeschneiderte Sicherheitsstrategie für Ihr Unternehmen."
    },
    {
      title: "Implementierung",
      description: "Implementieren Sie Sicherheitsmaßnahmen und Kontrollen in Ihrer Infrastruktur."
    },
    {
      title: "Testen & Validierung",
      description: "Überprüfen Sie die Wirksamkeit der Sicherheitsimplementierungen."
    },
    {
      title: "Überwachung",
      description: "Überwachen Sie Systeme kontinuierlich auf potenzielle Bedrohungen."
    },
    {
      title: "Laufende Optimierung",
      description: "Aktualisieren und verbessern Sie regelmäßig die Sicherheitsmaßnahmen."
    }
  ]
};
export const enCybersecurity = {
  // Hero Section
  title: "Cybersecurity Consulting Services",
  description: "Comprehensive security solutions to protect your digital assets, ensure compliance, and mitigate evolving cyber threats.",
  subtitle: "Cybersecurity Consulting Solutions",

  // Services Section
  servicesTitle: "Our Cybersecurity Expertise",
  servicesSubtitle: "End-to-end security services tailored to your organization's needs",
  services: {
    assessment: {
      title: "Security Assessments",
      description: "Identify vulnerabilities and risks with comprehensive security evaluations.",
      technologies: ["Penetration Testing", "Vulnerability Scanning", "Risk Analysis", "Threat Modeling", "Security Audits"]
    },
    compliance: {
      title: "Compliance Consulting",
      description: "Achieve and maintain regulatory compliance with industry standards.",
      technologies: ["GDPR", "HIPAA", "PCI DSS", "ISO 27001", "SOC 2"]
    },
    cloudsec: {
      title: "Cloud Security",
      description: "Secure your cloud infrastructure and applications with best practices.",
      technologies: ["AWS Security", "Azure Security", "GCP Security", "Cloud Architecture", "CSPM"]
    },
    incident: {
      title: "Incident Response",
      description: "Prepare for and respond to security breaches effectively.",
      technologies: ["IR Planning", "Forensics", "Threat Hunting", "Breach Containment", "Recovery"]
    },
    training: {
      title: "Security Training",
      description: "Educate your team on cybersecurity best practices and awareness.",
      technologies: ["Phishing Simulations", "Security Workshops", "Policy Development", "Tabletop Exercises", "Compliance Training"]
    },
    architecture: {
      title: "Security Architecture",
      description: "Design and implement robust security frameworks for your systems.",
      technologies: ["Zero Trust", "Network Security", "IAM Solutions", "Endpoint Protection", "Encryption"]
    }
  },

  // Process Section
  processTitle: "Our Security Process",
  processSteps: [
    {
      title: "Threat Assessment",
      description: "Evaluate your current security posture and identify vulnerabilities."
    },
    {
      title: "Strategy Development",
      description: "Create a customized security roadmap for your organization."
    },
    {
      title: "Implementation",
      description: "Deploy security measures and controls across your infrastructure."
    },
    {
      title: "Testing & Validation",
      description: "Verify the effectiveness of security implementations."
    },
    {
      title: "Monitoring",
      description: "Continuously monitor systems for potential threats."
    },
    {
      title: "Ongoing Optimization",
      description: "Regularly update and improve security measures."
    }
  ]
};


export const frCybersecurity = {
  title: "Services de Consultation en Cybersécurité",
  description: "Solutions de sécurité complètes pour protéger vos actifs numériques, garantir la conformité et atténuer les menaces cybernétiques évolutives.",
  subtitle: "Solutions de Consultation en Cybersécurité",

  servicesTitle: "Notre Expertise en Cybersécurité",
  servicesSubtitle: "Services de sécurité de bout en bout adaptés aux besoins de votre organisation",
  services: {
    assessment: {
      title: "Évaluations de Sécurité",
      description: "Identifier les vulnérabilités et les risques grâce à des évaluations de sécurité complètes.",
      technologies: ["Tests de Pénétration", "Analyse de Vulnérabilité", "Analyse de Risque", "Modélisation de Menace", "Audits de Sécurité"]
    },
    compliance: {
      title: "Consultation en Conformité",
      description: "Atteindre et maintenir la conformité réglementaire avec les normes de l'industrie.",
      technologies: ["RGPD", "HIPAA", "PCI DSS", "ISO 27001", "SOC 2"]
    },
    cloudsec: {
      title: "Sécurité Cloud",
      description: "Sécuriser votre infrastructure et vos applications cloud avec les meilleures pratiques.",
      technologies: ["Sécurité AWS", "Sécurité Azure", "Sécurité GCP", "Architecture Cloud", "CSPM"]
    },
    incident: {
      title: "Réponse aux Incidents",
      description: "Se préparer et répondre efficacement aux violations de sécurité.",
      technologies: ["Planification IR", "Analyse Forensique", "Chasse aux Menaces", "Confinement des Violations", "Récupération"]
    },
    training: {
      title: "Formation à la Sécurité",
      description: "Éduquer votre équipe sur les meilleures pratiques et la sensibilisation à la cybersécurité.",
      technologies: ["Simulations de Phishing", "Ateliers de Sécurité", "Développement de Politiques", "Exercices de Tabletop", "Formation à la Conformité"]
    },
    architecture: {
      title: "Architecture de Sécurité",
      description: "Concevoir et mettre en œuvre des cadres de sécurité robustes pour vos systèmes.",
      technologies: ["Zero Trust", "Sécurité Réseau", "Solutions IAM", "Protection des Points de Terminaison", "Chiffrement"]
    }
  },

  processTitle: "Notre Processus de Sécurité",
  processSteps: [
    {
      title: "Évaluation des Menaces",
      description: "Évaluer votre posture de sécurité actuelle et identifier les vulnérabilités."
    },
    {
      title: "Développement de Stratégie",
      description: "Créer une feuille de route de sécurité personnalisée pour votre organisation."
    },
    {
      title: "Mise en Œuvre",
      description: "Déployer des mesures et des contrôles de sécurité dans votre infrastructure."
    },
    {
      title: "Tests & Validation",
      description: "Vérifier l'efficacité des mises en œuvre de sécurité."
    },
    {
      title: "Surveillance",
      description: "Surveiller en continu les systèmes pour détecter d'éventuelles menaces."
    },
    {
      title: "Optimisation Continue",
      description: "Mettre à jour et améliorer régulièrement les mesures de sécurité."
    }
  ]
};